import React from 'react';
import { WaveRule } from '../../../../components/WaveRule';
import { ScrollToContainer, Section } from '../styled';
import { EasyToolsSection } from './EasyToolsSection';
import { HeroSection } from './HeroSection';
import { MoreCreatorToolsSection } from './MoreCreatorToolsSection';

export function CreatorToolsSection() {
  return (
    <ScrollToContainer id="creation-tools">
      <HeroSection />
      <Section>
        <WaveRule />
      </Section>
      <EasyToolsSection />
      <Section>
        <WaveRule isInverted={true} color="#FFFFFF" />
      </Section>
      <MoreCreatorToolsSection />
    </ScrollToContainer>
  );
}
